import type { UIEvent } from "react";

/**
 * Useful when you don't need to provide a callback
 */
export function noop(): void {
  return;
}

/**
 * Useful when you want to disable events
 */
export function blockEvent(e: Event | UIEvent): void {
  e.preventDefault();
  e.stopPropagation();
}
